import * as z from "zod";

export const cartContextSchema = z.object({
  existingCartId: z.string().nullable(),
  productIdsForRecommendations: z.array(z.string()),
  alreadyInCart: z.array(
    z.object({
      productId: z.string(),
      variantId: z.string(),
      quantity: z.number().optional(),
    }),
  ),
});
export type CartContext = z.infer<typeof cartContextSchema>;
